module.exports = __webpack_public_path__ + "img/Alena.9d69ebe0.png";